export default {
  placeholder: 'Voer restaurantnaam in',
  labels: {
    cant_find_place: 'Staat de locatie niet in de lijst?',
    reset_categories: 'Plaatscategorieën resetten',
  },
};
